export { ProxyApi as Api } from '@/proxyApi'
// export { Api } from './api-rx'
